import { Quote, Star } from "lucide-react";

const T = [
  {
    author: "Camille Rousseau",
    role: "DAF · Groupe Industriel",
    company: "180 salariés · 42 M€ CA",
    text: "On clôturait en 15 jours avec quatre outils différents. Aujourd'hui c'est J+3, dans un seul écran. Le rapprochement bancaire tout seul m'a fait gagner 12h par semaine.",
    metric: "Clôture J+15 → J+3",
    avatar: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    author: "Julien Moreau",
    role: "Fondateur & CEO",
    company: "Agence digitale · 24 pers.",
    text: "J'ai remplacé 6 abonnements (facturation, banque pro, notes de frais, contrats, paie, comptabilité) par un seul. Mes clients payent 8 jours plus vite grâce aux relances automatiques.",
    metric: "-8 jours de DSO",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    author: "Marie-Anne Delacroix",
    role: "Expert-comptable associée",
    company: "Cabinet 12 collaborateurs",
    text: "On gère 2,5× plus de dossiers par collaborateur. L'OCR apprend par client, donc au bout de 3 mois on ne fait presque plus de saisie manuelle. Nos clients adorent le portail.",
    metric: "×2,5 productivité",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
];

export default function Testimonials() {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs font-semibold uppercase tracking-widest text-[#4F46E5]">
            Ils nous font confiance
          </div>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0B0F17]">
            Des retours qui parlent d'eux-mêmes.
          </h2>
        </div>

        <div
          className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6"
          data-testid="testimonials-grid"
        >
          {T.map((t, i) => (
            <figure
              key={i}
              className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 flex flex-col relative overflow-hidden group hover:shadow-xl hover:shadow-slate-900/[0.06] hover:-translate-y-1 transition-all duration-300"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="h-8 w-8 text-indigo-100 mb-4" />
              <div className="flex items-center gap-1 mb-4">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <blockquote className="text-slate-800 leading-relaxed flex-1">
                {t.text}
              </blockquote>
              <div className="mt-6 pt-5 border-t border-slate-100 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt=""
                  className="h-11 w-11 rounded-full object-cover ring-2 ring-white"
                  loading="lazy"
                />
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-sm text-[#0B0F17]">
                    {t.author}
                  </div>
                  <div className="text-xs text-slate-500 truncate">{t.role}</div>
                  <div className="text-[10px] text-slate-400 truncate">
                    {t.company}
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <div className="text-[10px] font-semibold uppercase tracking-widest text-slate-400">
                    Impact
                  </div>
                  <div
                    className="text-xs font-bold text-emerald-600 tabular-nums"
                    style={{ fontFamily: "'JetBrains Mono', monospace" }}
                  >
                    {t.metric}
                  </div>
                </div>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
